/**
 * The address value that means "every region, on purpose".
 *
 * No region in the address is a default, and a default can be a viewer's own
 * region. "all" is the explicit choice, so picking All regions sticks in the
 * address and the default cannot trap anyone. It is reserved on the server, so
 * no region can be named "all", and it is turned into national scope here, in
 * one place: it must never reach an API as a region.
 */
export const ALL_REGIONS = 'all';

export const isAllRegionsChoice = (value: string | null | undefined): boolean =>
  value === ALL_REGIONS;

/** The region slug an address names, or undefined for national scope. */
export function regionSlugFromParam(value: string | null | undefined): string | undefined {
  if (!value || isAllRegionsChoice(value)) return undefined;
  return value;
}
